import React from "react";
import "./home.css";
import CompanyProfile from "./companyprofile.pdf";
import Typewriter from "typewriter-effect";
import Fade from "react-reveal/Fade";
import { BsMoonStarsFill, BsFillSunFill } from "react-icons/bs";

const Home = ({ theme, handleChangeTheme }) => {
  return (
    <div className="container-fluid home" id="home">
      <div className="theme-change" onClick={() => handleChangeTheme()}>
        {theme === "light" ? (
          <p>
            <BsMoonStarsFill size={40} />
          </p>
        ) : (
          <p className="theme-icon">
            <BsFillSunFill size={40} />
          </p>
        )}
      </div>

      <Fade left>
        <div className="container home-content">
          <h1 className="h1-text-color">
            <Typewriter
              options={{
                strings: [
                  "Welcome to Value Seeds Limited!",
                  "We are leading the transformation of the seed system business in West Africa",
                ],
                autoStart: true,
                loop: true,
                delay: 5,
              }}
            />
          </h1>

          <h3>
            <Typewriter
              options={{
                strings: [
                  "Value Seeds Limited is an indigenous Nigerian seed Company incorporated in September 14, 2009, focused on the production and distribution of high-quality field crops and vegetable seeds. We are a leading agricultural value chain solution provider, specializing in seed research, multiplication, processing and distribution.",
                  "Our Vision: To lead the transformation of the seed system in West Africa.",
                  "Our Mission: To continuously commercialize innovative agricultural seed technologies that will increase farmers’ yields, enhance nutrition and build livelihoods through expertise, technology application and being a customer centric seed company.",
                  "Our Core Values: Integrity, Accountability, Innovation, Professionalism, Resourcefulness, Value Addition",
                ],
                autoStart: true,
                loop: true,
                delay: 10,
              }}
            />
          </h3>
		  <a href={CompanyProfile} download={"Value Seeds Limited Profile.pdf"}>
          <span className="view-details-home-button">Download Our Company Profile</span>
		  </a>
        </div>
      </Fade>
    </div>
  );
};

export default Home;
